import { render } from "./RelatedProductsComponent.vue?vue&type=template&id=43080ffd"
import script from "./RelatedProductsComponent.vue?vue&type=script&lang=js"
export * from "./RelatedProductsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"platform/themes/iteam/assets/js/components/RelatedProductsComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "43080ffd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('43080ffd', __exports__)) {
    api.reload('43080ffd', __exports__)
  }
  
  module.hot.accept("./RelatedProductsComponent.vue?vue&type=template&id=43080ffd", () => {
    api.rerender('43080ffd', render)
  })

}


export default __exports__